type StatusPillProps = {
  label: string;
  tone: "healthy" | "warning" | "critical" | "neutral";
};

export function StatusPill({ label, tone }: StatusPillProps) {
  return <span className={`status-pill status-pill--${tone}`}>{label}</span>;
}
